import Model from '@/models/Model'

export default class AccAccountingSeatType extends Model {
    resource() {
        return 'acc_accounting_seat_type'
    }
}